import React from "react";

function ManagementIconArrowTop({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 10 10">
      <path
        id="Polygone_160"
        data-name="Polygone 160"
        d="M4.462.645a.7.7,0,0,1,1.076,0L9.043,4.852A.7.7,0,0,1,8.505,6H1.495A.7.7,0,0,1,.957,4.852Z"
        fill="#fafafa"
      />
    </svg>
  );
}

export { ManagementIconArrowTop };
